import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";

import {periodsService} from "../../../services/settings-services";


const initialState = {
    periods: [],
    status: null,
    error: null,
    trigger: 0,
}

const getAllPeriods = createAsyncThunk(
    'periodsSlice/getAllPeriods',
    async (_, {rejectWithValue}) => {
        try {
            return await periodsService.getAll();
        }catch (e) {
            return rejectWithValue(e.response?.data?.message || "Something went wrong");
        }
    }
);


const periodSlice = createSlice({
    name: 'periodSlice',
    initialState,
    reducers: {
        changeTrigger: (state, action) => {
            state.trigger = state.trigger + 1;
        },
    },
    extraReducers: builder =>
        builder
            .addCase(getAllPeriods.pending, state => {
                state.status = 'Loading';
                state.error = null;
            })
            .addCase(getAllPeriods.fulfilled, (state, action) => {
                state.status = 'fulfilled';
                state.periods = action.payload;
            })
            .addCase(getAllPeriods.rejected, (state, action) => {
                state.status = 'rejected';
                state.error = action.payload;
            })
});

const {reducer: periodsReducer, actions} =periodSlice;
const periodsActions = {
    ...actions,
    getAllPeriods
}

export {
    periodsReducer,
    periodsActions
}